<style lang="less" scope>
.article {
  width: 1000px;
  margin: 0 auto;
}
.content {
  width: 1000px;
  padding: 0 10% 20px 10%;
  box-sizing: border-box;
}
h1 {
  text-align: center;
  height: 80px;
  line-height: 80px;
}
h2 {
  font-size: 14px;
  text-align: center;
  font-weight: 200;
  height: 35px;
  line-height: 35px;
  border-top: 1px dashed #f0f0f0;
  border-bottom: 1px dashed #f0f0f0;
  margin-bottom: 10px;
}
.content-text .txt-1 {
  font-size: 17px;
  line-height: 3;
  margin: 16px 0;
  text-indent: 2em;
  font-weight: 700;
  text-align: center;
  color: #4c4343;
}
.content-text .txt-2 {
  font-size: 15px;
  line-height: 1;
  margin: 16px 0;
  text-indent: 2em;
  font-weight: 700;
  text-align: center;
}
.content-text .txt-3 {
  font-size: 15px;
  line-height: 2;
  margin: 16px 0;
  text-indent: 2em;
  color: #333;
}
.img-box {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.img-box img {
  width: 80%;
}
.footer-tip {
  width: 100%;
  text-align: right;
}
.footer-tip div {
  height: 40px;
  line-height: 40px;
}
</style>
<template>
  <div class="article">
    <div class="content">
      <h1>{{ article.title }}</h1>
      <h2>发稿时间：{{ article.time }} 来源：{{ article.source }}</h2>
      <div class="content-text" v-for="(item, index) in article.p" :key="index">
        <div class="header" v-if="item.header">{{ item.header }}</div>
        <div class="txt-1" v-if="item.h1">{{ item.h1 }}</div>
        <div class="txt-2" v-if="item.h2">{{ item.h2 }}</div>
        <div class="txt-3" v-if="item.h3">{{ item.h3 }}</div>
      </div>
      <div class="img-box" v-if="article.imgUrl">
        <img :src="article.imgUrl" :alt="article.title" />
      </div>
      <div class="footer-tip" v-if="article.footer">
        <div v-for="(item, index) in article.footer" :key="index">
          {{ item }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      articleList: [],
      article: {},
    };
  },
  methods: {
    reqArticleList() {
      axios.get("./data.json").then((res) => {
        this.articleList = res.data.articleList;
        this.article = this.articleList[Number(this.$route.query.id) - 1];
      });
    },
  },
  mounted() {
    this.reqArticleList();
  },
};
</script>

